module.exports = __webpack_public_path__ + "img/bg-icon1.ab81d9b1.png";